export class CargoTemperature {
    cargoNumber: string;
    commodityId: number;
    isOnBoard: boolean;
    isNotRequiringHeating: boolean;
    temperature?: number;
    cargoLoadingTemperature?: number;

    constructor(
        cargoNumber: string,
        commodityId: number,
        isOnBoard: boolean,
        isNotRequiringHeating: boolean,
        temperature?: number,
        cargoLoadingTemperature?: number
    ) {
        this.cargoNumber = cargoNumber;
        this.commodityId = commodityId;
        this.isOnBoard = isOnBoard;
        this.isNotRequiringHeating = isNotRequiringHeating;
        this.temperature = temperature;
        this.cargoLoadingTemperature = cargoLoadingTemperature;
    }
}
